import React, { Component } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { clearNotification } from '../actions';
import MobileChecker from '../utils/MobileChecker';

export class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timer: null,
    };
  }

  static defaultProps = {
    pathname: PropTypes.string,
    notification: PropTypes.object,
    rcl_notification: PropTypes.object,
    maintenance_banner: PropTypes.object,
    new_feature_banner: PropTypes.object,
  };

  classNames() {
    return classNames(
      'ds-banner',
      '_alignCenter',
      this.notificationContent.className,
      { _displayBlock: this.isNotificationOpen },
      { _displayNone: !this.isNotificationOpen }
    );
  }

  bodyClassNames() {
    let fontColor =
      this.notificationContent.className === '-warning' ? '-base' : '-inverted';
    return `copy emphasize ${fontColor}`;
  }

  duration = () => {
    return this.props.notification.duration * 1000;
  };

  startTimer = () => {
    if (this.duration() < 0 && this.notificationContent.body !== '') return;
    this.setState({
      timer: setTimeout(() => this.props.clearNotification(), this.duration()),
    });
  };

  hideBanner = (e) => {
    e.preventDefault();
    clearTimeout(this.state.timer);
    this.setState({ timer: null });
    this.props.clearNotification();
  };

  redirectToApply() {
    this.props.push('/apply-now');
  }

  renderHeader(text){
    if(!this.hasRclBanner){
      return(
        <p className='subhead' data-testid='notification-header'>
          {text}
        </p>
      );
    }
    return(
      <small className='preamble' data-testid='notification-header'>
        {text}
      </small>
    );
  }

  renderContent(text){
    if (!MobileChecker()) return (
      <span className={this.bodyClassNames()} data-testid='notification-body'>
        {text}
      </span>
    );
    return (
      <p className={this.bodyClassNames()} data-testid='notification-body'>
        {text}
      </p>
    );
  }

  renderCta() {
    if (!this.hasRclBanner) return;
    return (
      <a
        onClick={this.redirectToApply.bind(this)}
        className='ds-btn _outline --micro _marginLeft--large-tabletUp _marginLeft--small-tabletUp -warning _marginTop--small-mobileOnly _displayInlineBlock'
      >
        Apply Now
      </a>
    );
  }

  renderCloseIcon() {
    if (!this.isDimissable) return;
    return (
      <a
        className='dismiss'
        role='button'
        onClick={this.hideBanner}
        data-testid='notification-dismiss'
      >
        <i className='materialIcon --micro -inverted'> close </i>
      </a>
    );
  }

  get isNotificationOpen() {
    return this.notificationContent.open;
  }

  get hasRclBanner() {
    return (
      !this.props.maintenance_banner.open &&
      this.props.rcl_notification.body !== '' &&
      !this.props.notification.open
    );
  }

  get notificationContent() {
    if (this.hasRclBanner && this.props.pathname === '/') {
      return this.props.rcl_notification;
    }
    return this.props.notification;
  }

  get isDimissable() {
    return this.notificationContent.dismissable;
  }

  render() {
    const { header, body } = this.notificationContent;

    return (
      <div className={this.classNames()} data-testid='notification-container'>
        {this.renderHeader(header)}
        {this.renderContent(body)}
        {this.renderCta()}
        {this.renderCloseIcon()}
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.notification.open !== this.props.notification.open &&
      !!this.props.notification.open
    )
      this.startTimer();
  }
}

const mapStateToProps = (state) => {
  return {
    pathname: window.location.pathname,
    notification: state.shared.ui.notification,
    rcl_notification: state.shared.ui.rcl_notification,
    maintenance_banner: state.shared.ui.maintenance_banner,
    new_feature_banner: state.shared.ui.new_feature_banner
    };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    clearNotification: () => dispatch(clearNotification()),
    push: (url) => dispatch(push(url))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notification);



// WEBPACK FOOTER //
// ./src/features/shared/containers/Notification.js